import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { scrollToId } from "@/lib/scroll";
import { useCtaActions } from "@/lib/ctaActions";
import { useI18n } from "@/i18n";

export function MobileBottomCTA() {
  const { goFirstListing } = useCtaActions();
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "tween", duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-re-line bg-white/90 p-3 backdrop-blur-xl lg:hidden"
          data-testid="mobile-bottom-cta"
        >
          <div className="flex items-center gap-3">
            <button
              onClick={() => scrollToId("pakketten")}
              className="flex-1 rounded-full border border-re-line py-3 text-sm font-semibold text-re-ink"
              data-testid="mobile-bottom-packages"
            >
              {t("mobileCta.packages")}
            </button>
            <button
              onClick={goFirstListing}
              className="flex-1 rounded-full bg-gradient-red py-3 text-sm font-semibold text-white"
              data-testid="mobile-bottom-start"
            >
              {t("mobileCta.start")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
